var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.067C5.971 1.067 1.067 5.97 1.067 12S5.97 22.933 12 22.933 22.933 18.03 22.933 12 18.03 1.067 12 1.067M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.74a.527.527 0 01-.522-.534V6.794c0-.295.233-.533.522-.533.289 0 .522.238.522.533v10.412a.527.527 0 01-.522.533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.206 12.522H6.794A.527.527 0 016.26 12c0-.289.238-.522.533-.522h10.412c.295 0 .533.233.533.522a.527.527 0 01-.533.522"
  }))));
}
export default SvgAdd;